module.exports = __webpack_public_path__ + "static/profile-67ef07e63d40e4e9b2a8d492424b4785.png";